import React, { useEffect, useRef, useState } from "react";
import { Chart, registerables } from "chart.js";
import BASE_URL from "components/BaseUrl/apiConfig";

// Register Chart.js components
Chart.register(...registerables);

const ExpByWeekOfYears2 = () => {
  const chartRef = useRef(null);
  const chartInstanceRef = useRef(null); // Reference for storing the chart instance
  const currentYear = new Date().getFullYear(); // Get current year
  const [currency, setCurrency] = useState("");
  const [selectedYear, setSelectedYear] = useState(currentYear); // Set current year as default
  const storedUserData = localStorage.getItem("userData");
  let userId = "";
  let groupId = "";

  if (storedUserData) {
    const userData = JSON.parse(storedUserData);
    userId = userData.userId;
    groupId = userData.groupId;
  }

  useEffect(() => {
    const fetchCurrencyData = async () => {
      try {
        const response = await fetch(
          `${BASE_URL}/api/Users/GetCurrencyByUserId?groupId=${groupId}`
        );
        const data = await response.json();
        setCurrency(data.currency);
      } catch (error) {
        console.error("Error fetching currency data:", error);
      }
    };

    fetchCurrencyData();
  }, [groupId]);

  const createChart = (labels, totalCredit, totalDebit) => {
    if (chartInstanceRef.current) {
      chartInstanceRef.current.destroy(); // Destroy the old chart instance if it exists
    }

    chartInstanceRef.current = new Chart(chartRef.current, {
      type: "line",
      data: {
        labels: labels,
        datasets: [
          {
            label: "Total Credit",
            data: totalCredit,
            borderColor: "rgba(75, 192, 192, 1)", // Blue color for Credit
            backgroundColor: "rgba(75, 192, 192, 0.2)",
            pointBackgroundColor: "rgba(75, 192, 192, 1)",
            pointRadius: 6,
            pointHoverRadius: 8,
            tension: 0.1, // Smooth curve
            stepped: true, // Stepped line
          },
          {
            label: "Total Debit",
            data: totalDebit, // Debit shown as negative
            borderColor: "rgba(255, 99, 132, 1)", // Red color for Debit
            backgroundColor: "rgba(255, 99, 132, 0.2)",
            pointBackgroundColor: "rgba(255, 99, 132, 1)",
            pointRadius: 6,
            pointHoverRadius: 8,
            tension: 0.1,
            stepped: true,
          },
        ],
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          title: {
            display: true,
          },
          tooltip: {
            backgroundColor: "rgba(0, 0, 0, 0.8)", // Dark black background
            titleColor: "white", // White title text
            bodyColor: "white", // White body text
            borderColor: "rgba(255, 255, 255, 0.5)", // White border
            borderWidth: 1, // Border width
            padding: 10, // Padding around text
          },
        },
        plugins: {
          datalabels: {
            display: true,
            color: ["black"],
            formatter: (value) => value,
            font: {
              weight: "bold",
              size: 12,
              family: "Courier",
            },
            align: "start",
            offset: -10,
            padding: {
              top: 10,
              bottom: 10,
            },
            labels: {
              title: {
                font: {
                  weight: "bold",
                },
              },
            },
          },
        },
        scales: {
          x: {
            beginAtZero: true,
            ticks: {
              maxRotation: 45,
              minRotation: 45,
            },
            title: {
              display: true,
              text: "Weeks",
            },
          },
          y: {
            beginAtZero: true,
            suggestedMin: Math.min(...totalDebit) - 10,
            suggestedMax: Math.max(...totalCredit) + 10,
            ticks: {
              stepSize: 1,
              callback: function (value) {
                return value.toFixed(2);
              },
            },
            title: {
              display: true,
              text: `Amount (${currency})`,
            },
          },
        },
      },
    });
  };

  const fetchData = async () => {
    try {
      const response = await fetch(
        `${BASE_URL}/api/Analytics/GetExpensesByWeek?groupId=${groupId}&year=${selectedYear}`
      );
      const data = await response.json();

      const labels = data.map(
        (item) => `${item.weekStartDate} - ${item.weekEndDate}`
      );
      const totalCredit = data.map((item) => item.totalCredit);
      const totalDebit = data.map((item) => item.totalDebit * -1); // Debit shown as negative

      createChart(labels, totalCredit, totalDebit); // Create or update the chart
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    fetchData(); // Fetch data when selectedYear or currency changes
  }, [currency, selectedYear]);

  const handleYearChange = (e) => {
    setSelectedYear(e.target.value);
  };

  const pastFiveYears = Array.from({ length: 5 }, (_, i) => currentYear - i); // Generate array of past 5 years including current year

  return (
    <>
      <div className="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg !rounded bg-white">
        <div className="rounded mr-4 pl-4 mt-4 bg-transparent">
          <div className="flex justify-between">
            {" "}
            {/* Align elements in a row */}
            <h2
              className="text-blueGray-700 text-xl font-semibold"
              style={{ fontSize: "1rem" }}
            >
              Weeks wise Expenses ({currency})
            </h2>
            {/* Year Dropdown */}
            <select
              className="bg-white-800 text-black border border-white-600 rounded px-6 py-1 outline-none focus:outline-none w-32"
              id="year-select"
              value={selectedYear}
              onChange={handleYearChange}
              style={{ marginRight: "15px" }}
            >
              {/* Populate with past 5 years including current year */}
              {pastFiveYears.map((year) => (
                <option key={year} value={year}>
                  {year}
                </option>
              ))}
            </select>
          </div>

          <div className="relative" style={{ height: "700px", width: "100%" }}>
            <canvas ref={chartRef} style={{ width: "100%", height: "100%" }} />
          </div>
        </div>
      </div>
    </>
  );
};

export default ExpByWeekOfYears2;
